import GlassOverlay from '../GlassOverlay'
import './ScanProductFlow.css'

function ManualAddGlyph() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
      <rect x="4.5" y="3.5" width="15" height="17" rx="2.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M8 8h8M8 12h8M8 16h5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  )
}

function PhotoInterpretGlyph() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
      <path d="M8.2 7.2 9.6 5.6h4.8l1.4 1.6H19a2 2 0 0 1 2 2v8.2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9.2a2 2 0 0 1 2-2h3.2Z" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <circle cx="12" cy="13" r="2.7" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <path d="M16.8 6.2 18 4.6M18.8 7.4h2" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  )
}

export default function AddProductChooser({ isOpen, onClose, onManual, onScan, returnFocusRef }) {
  return (
    <GlassOverlay
      isOpen={isOpen}
      onClose={onClose}
      returnFocusRef={returnFocusRef}
      labelledBy="scan-add-chooser-title"
      describedBy="scan-add-chooser-hint"
      panelClassName="scan-add-chooser"
      followPointer={false}
    >
      <div className="scan-add-chooser">
        <header className="scan-add-chooser-header">
          <div>
            <h2 id="scan-add-chooser-title">Ajouter un produit</h2>
            <p id="scan-add-chooser-hint">Sélectionnez une méthode d’ajout.</p>
          </div>
          <button type="button" className="scan-icon-btn" onClick={onClose} aria-label="Fermer">
            <span aria-hidden="true">✕</span>
          </button>
        </header>
        <div className="scan-add-chooser-actions">
          <button type="button" className="scan-add-chooser-option" onClick={onManual}>
            <span className="scan-add-chooser-icon">
              <ManualAddGlyph />
            </span>
            <span>Ajout manuel</span>
          </button>
          <button type="button" className="scan-add-chooser-option" onClick={onScan}>
            <span className="scan-add-chooser-icon">
              <PhotoInterpretGlyph />
            </span>
            <span>Ajout par interprétation photographique</span>
          </button>
        </div>
      </div>
    </GlassOverlay>
  )
}
